function watchHiddenChange(selector, callback, interval) {
	var inputs = document.querySelectorAll(selector);
	var values = new Map();

	inputs.forEach(function(input) {
		values.set(input, input.value);
	});

	if(!interval) {
		interval = 250;
	}

	setInterval(function() {
		inputs.forEach(function(input) {
		var oldValue = values.get(input);
		var newValue = input.value;

		if (oldValue !== newValue) {
			values.set(input, newValue);
			callback(newValue, input);
		}
		});
	}, interval);
}

function FormEvents() {
	var self = this;
	this.init();
}

FormEvents.prototype.init = function() {
	var self = this;
	self.lastIndex = 0;
	self.handleSelectScroll();
	self.handleCustomSelectEvents();
	self.handleCustomNumberInput();
	self.handleCustomFileInput();
	self.handleJSTracking();
};

FormEvents.prototype.updateLeadsDataFromCombination = function($scope) {
	$scope = $scope || $('.container-form[data-validCombinations]').first();
	if (!$scope.length) return;

	var $data1 = $scope.find('input.form-leads-data1');
	var $data2 = $scope.find('input.form-leads-data2');
	if (!$data1.length || !$data2.length) return;

	var validCombinations = JSON.parse($scope.attr('data-validCombinations'));
	var requiredKeys = ['cities', 'levels', 'fields', 'types'];
	var currentSelections = {};

	$scope.find('.select-dropdown-background.-js-tracking').each(function() {
		var key = $(this).attr('data-key') || $(this).data('key');
		var val = $(this).closest('.select-container').find('input.-js-tracking-val').val();
		if (key && val) {
			currentSelections[key] = val;
		}
	});

	var complete = requiredKeys.every(function(k) {
		return currentSelections[k] && currentSelections[k] !== '';
	});

	var data1 = '';
	var data2 = '';

	if (complete) {
		var matched = validCombinations.find(function(row) {
			return requiredKeys.every(function(k) {
				return row[k] === currentSelections[k];
			});
		});
		if (matched) {
			data1 = matched.cities || '';
			data2 = matched.links || '';
		}
	}

	$data1.val(data1);
	$data2.val(data2);
};

FormEvents.prototype.handleJSTracking = function() {
	var self = this;
	//var validCombinations;
	if ($('.-js-tracking-val').length) {

		self.validCombinations = JSON.parse($('.container-form').attr('data-validCombinations'));
		var $selects = $('.select-dropdown-background.-js-tracking');

		var omit = function(obj, keyToRemove) {
			var result = {};
			
			for (var key in obj) {
				if (obj.hasOwnProperty(key) && key !== keyToRemove) {
				result[key] = obj[key];
				}
			}
			
			return result;
		};

		var updateSelects = function() {
			self.updateOn = false;
			var currentSelections = {};
			
			//var lastIndex = 0;

			$selects.each(function() {
				var val = $(this).find('a.-active').attr('data-value');
				//console.log($(this));
				//console.log('Wartosc: '+ val);
				if (val) {
					var key = $(this).attr('data-key') || $(this).data('key');
					currentSelections[key] = val;
					//lastIndex = $(this).closest('.dropdown-wrapper').attr('data-index');
				}

				if (val=="") {
					$(this).closest('.dropdown-wrapper').find('.select-box__text').addClass('placeholder');
				} else {
					$(this).closest('.dropdown-wrapper').find('.select-box__text').removeClass('placeholder');
				}
			});
			//console.log(currentSelections);
			//console.log("lastIndex: " + lastIndex);

			$selects.each(function() {
				var $thisSelect = $(this);
				var thisKey = $thisSelect.attr('data-key') || $thisSelect.data('key');

				var activeIndex = $(this).closest('.dropdown-wrapper').attr('data-index');
				//console.log('activIndex: ' + activeIndex);
				if (activeIndex > self.lastIndex) {
					//console.log('Parsuje opcje: ' + activeIndex);

					//console.log($thisSelect);
					//console.log('klucz: ' + thisKey);

					var otherSelections = omit(currentSelections, thisKey);
					//console.log(otherSelections);

					var possibleRows = self.validCombinations.filter(function(row) {
						for (var key in otherSelections) {
							if (otherSelections.hasOwnProperty(key)) {
								if (row[key] !== otherSelections[key]) {
									return false;
								}
							}
						}
						return true;
					});
					
					// if (activeIndex==3) {
					// 	console.log('mozliwe');
					// 	console.log(possibleRows);
					// }

					var allowedValues = [];
					possibleRows.forEach(function(row) {
						var val = row[thisKey];
						
						// if (activeIndex==3) {
						// 	console.log("Szukam: " + val);
						// 	console.log("allowedValues.indexOf: " + allowedValues.indexOf(val));
						// }

						if (allowedValues.indexOf(val) === -1) {
							allowedValues.push(val);
						}
					});


					var activeValue = $thisSelect.find('a.-active') ? $thisSelect.find('a.-active').attr('data-value') : "";
					// if (activeIndex==3) {
					// 	console.log(activeValue);
					// 	console.log('dozwolone');
					// 	console.log(allowedValues);
					// }
					//if (activeIndex==2) console.log("activeValue: " + activeValue);
					var reset = false;
					$thisSelect.find('a').each(function () {
						var optionValue = $(this).attr('data-value');
						//if (activeIndex==3) console.log(optionValue);

						if (optionValue === "") {
							return;
						}

						reset = true; //kasowanie w dol wszystkiego ???

						if (allowedValues.indexOf(optionValue) !== -1) {
							//console.log('pokaz ' + optionValue);
							$(this).show();
								//console.log($(this));
						} else {
							$(this).hide();
							//console.log('ukryj ' + optionValue);
							if (optionValue!="" && activeValue === optionValue) {
								reset = true; // jesli ukryta opcja byla zaznaczona
							}
							
						
						}
					});

					//chowam aktywna opcjem jesli wybrana to reset selecta
					//if (optionValue!="" && activeValue === optionValue) {
					if (reset) {
						//console.log('Robie reset ' + activeIndex);
						//console.log($thisSelect.closest('.select-container').find('input[type=hidden]'));
						$thisSelect.closest('.select-container').find('input[type=hidden]').val("");

						//reset selecta
						$thisSelect.closest('.dropdown-wrapper').find('a').removeClass('-active').show();
						$thisSelect.closest('.dropdown-wrapper').find('a:first').addClass('-active');
						var text = $thisSelect.closest('.dropdown-wrapper').find('a:first').text();
						$thisSelect.closest('.dropdown-wrapper').find('.select-box__text').addClass('placeholder');
						$thisSelect.closest('.dropdown-wrapper').find('.select-box__text').text(text);
					}
				}

				self.updateOn = true;

			});

			self.updateLeadsDataFromCombination($('.container-form[data-validCombinations]').first());
		};

		self.updateOn = true; //start parametru
		watchHiddenChange('.-js-tracking-val', function(val, el) {
			//console.log("Zmiana:", val);
			//console.log("Element:", el);

			if (self.updateOn)
				updateSelects();

			self.updateLeadsDataFromCombination($(el).closest('.container-form'));

			//$('#select-1555-dropdown').append("<a href='#' data-value='INŻYNIERIA OPROGRAMOWANIA' class='select-dropdown-element tab-block'>INŻYNIERIA OPROGRAMOWANIA</a>")
		});

		$selects.each(function(i,v) {
			//console.log($(v).find('a:first')[0]);
			$(v).find('a:first').click();
			$(v).closest('.dropdown-wrapper').find('.select-box__text').addClass('placeholder');
		});

	}
};

FormEvents.prototype.handleSelectScroll = function() {
	var self = this;

	$('.select-dropdown-background').each(function(){
		$(this).niceScroll({
			cursoropacitymax: 0.3,
			cursorborder: '2px solid #000',
			horizrailenabled: false,
			bouncescroll: true,
			autohidemode: true
		});
		$(this).on('touchmove', function(e) {
			e.preventDefault();
		});
	});
};


FormEvents.prototype.handleCustomSelectEvents = function() {
	var self = this;

	$('body').on('click', '.fields-leads-trigger', function(e) {
		e.preventDefault();
		$(this).closest('.fields-info').find('.fields-leads-trigger').removeClass('-active');
		$(this).addClass('-active');
		$(this).closest('.scroll-container').getNiceScroll().resize();
	});

	$('body').on('click', '.fields-leads-form input[type=checkbox] + label', function(e) {
		e.preventDefault();
		$(this).parent().find('input[type=checkbox]').prop('checked', function() {return !$(this).prop('checked');});
	});

	$('body').on('click keydown', '.dropdown-wrapper', function(e) {
		if (e.type === 'click' || ['Enter', ' ', 'Escape'].includes(e.key)) {
			e.stopPropagation();
			e.preventDefault();
			var that = this;
			if ($(this).hasClass('-visible')) {
				$(this).removeClass('-visible');
				$(this).find('.select-box').focus();
				$(this).find('.select-dropdown-background button').removeAttr('tabindex');
			} else {
				$('.dropdown-wrapper').removeClass('-visible');
				setTimeout(function() {
					$(that).find('.select-dropdown-background').getNiceScroll().resize();
					$($(that).find('.select-dropdown-background').getNiceScroll()[0].rail[0]).addClass('-binded');
				}, 100);
				$(this).addClass('-visible');
				$(this).find('.select-dropdown-background button').attr('tabindex', '2');
				$(this).find('.select-dropdown-background').focus();
			}
			$(that).closest('.scroll-container').getNiceScroll().resize();
		}
	});

	$('body').on('click keydown', '.dropdown-wrapper .select-dropdown-element', function(e) {
		var element_class = $(this).parent().find('.select-dropdown-element.-exists').length ? '.select-dropdown-element.-exists' : '.select-dropdown-element';
		var first_element = $(this).parent().find(element_class).first();
		var last_element = $(this).parent().find(element_class).last();
		if (e.key == 'Tab' && $(e.target).is(last_element)) {
			e.preventDefault();
			first_element.focus();
		}
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.stopPropagation();
			e.preventDefault();
			var text = $(this).text();
			var form = $(this).closest('.dropdown-wrapper').attr('data-name');
			var value = $(this).attr('data-value');
			var dropdown = $(this).closest('.dropdown-wrapper');
			if ($(this).closest('.dropdown-wrapper').attr('data-index'))
				self.lastIndex = $(this).closest('.dropdown-wrapper').attr('data-index');
			$(this).closest('.dropdown-wrapper').find('.select-box__text').text(text);
			$(this).siblings().removeClass('-active');
			$(this).addClass('-active');
			if ($(this).attr('data-value') == 0)
				dropdown.addClass('-default-item-picked');
			else
				dropdown.addClass('-item-picked');
			var oldValue = $(this).closest('.select-block').find('input[name="'+form+'"]').val();
			$(this).closest('.select-block').find('input[name="'+form+'"]').val(value);
			if (oldValue != value) {
				$(this).closest('.select-container').removeClass('filter-done');
				self.updateLeadsDataFromCombination($(this).closest('.container-form'));
			}
			$(this).closest('.dropdown-wrapper').click();
		}
	});

	$('body').on('click', '.dropdown-wrapper .select-box__remove', function(e) {
		
		e.stopPropagation();

		var input = $(this).closest('.select-block').find('input[type="hidden"]');
		var first_val = $(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').first().attr('data-value');
		var text;

		$(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').removeClass('-active');
		$(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element').first().addClass('-active');

		if ($(this).closest('.dropdown-wrapper').attr('data-default') && $(this).closest('.dropdown-wrapper').attr('data-default') != "") {
			input.val('');
			text = $(this).closest('.dropdown-wrapper').attr('data-default');
		} else {
			text = $(this).closest('.dropdown-wrapper').find('.select-dropdown-wrapper').find('.select-dropdown-element.-active').text();
			input.val(first_val);
		}
		
		var dropdown = $(this).closest('.dropdown-wrapper');

		$(this).closest('.dropdown-wrapper').find('.select-box__text').text(text);
		$(this).closest('.dropdown-wrapper').removeClass('-item-picked').addClass('-default-item-picked');
		self.updateLeadsDataFromCombination($(this).closest('.container-form'));
	});

	$('body').on('click', function() {
		$('.dropdown-wrapper').removeClass('-visible');
	});
};

FormEvents.prototype.handleCustomNumberInput = function() {
	var self = this;
	$('.number-input input').on('input', function() {
		var min = parseInt($(this).attr('min'));
		var max = parseInt($(this).attr('max'));

		if (!isNaN(parseInt($(this).val()))) {
			if (parseInt($(this).val()) <= max) {
				if (parseInt($(this).val()) <= 0) {
					$(this).val(min);
				} else {
					$(this).val(parseInt($(this).val()));
				}
			} else {
				$(this).val(max);
			}
		}
		else {
			$(this).val(0);
		}
	});
	$('.number-input .plus').on('click', function(e) {
		var plusVal = parseInt($(this).siblings('input[type="number"]').val());
		if (!plusVal)
			plusVal = 0;
		if (plusVal != $(this).siblings('input[type="number"]').attr('max'))
			$(this).siblings('input[type="number"]').val(plusVal+=1);
		else
			$(this).siblings('input[type="number"]').val(parseInt($(this).siblings('input[type="number"]').attr('max')));
	});
	$('.number-input .minus').on('click', function(e) {
		var minusVal = parseInt($(this).siblings('input[type="number"]').val());
		if (!minusVal)
			minusVal = 0;
		if (minusVal != $(this).siblings('input[type="number"]').attr('min'))
			$(this).siblings('input[type="number"]').val(minusVal-=1);
		else 
			$(this).siblings('input[type="number"]').val(parseInt($(this).siblings('input[type="number"]').attr('min')));
	});
};

var number_of_files;
FormEvents.prototype.handleCustomFileInput = function() {
	var self = this;
	$('body').on('change', 'input[type="file"]', function() {
		var self = this;
		$(this).siblings('.files').html('');
		var filesLength = self.files.length;
		number_of_files = parseInt( $(this).attr('data-number_of_files') );
		if (filesLength > number_of_files)
			filesLength = number_of_files;

		if ($('form.cms-form.ajax').length) {
			uploadajaxOper('reset', null, function() {
				uploadajax(filesLength, 0);
			});
			for (var c = 0; c < filesLength; c++) {
				$(self).siblings('.files').append('<li class="upload-percent" data-nr="'+c+'"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23px" height="32px"><path fill-rule="evenodd" d="M14.414,-0.000 L-0.000,-0.000 L-0.000,32.000 L23.000,32.000 L23.000,8.586 L14.414,-0.000 ZM15.000,3.414 L19.586,8.000 L15.000,8.000 L15.000,3.414 ZM21.000,30.000 L2.000,30.000 L2.000,2.000 L13.000,2.000 L13.000,10.000 L21.000,10.000 L21.000,30.000 ZM10.000,10.000 L6.000,10.000 L6.000,12.000 L10.000,12.000 L10.000,10.000 ZM6.000,16.999 L17.000,16.999 L17.000,15.000 L6.000,15.000 L6.000,16.999 ZM6.000,22.000 L17.000,22.000 L17.000,20.000 L6.000,20.000 L6.000,22.000 ZM6.000,27.000 L15.000,27.000 L15.000,25.000 L6.000,25.000 L6.000,27.000 Z"/></svg><div class="upload-item"><p class="clamp">'+self.files[c].name+'</p><div class="upload-bar"><div class="done"></div></div></div></li>');
			}
			$(self).closest('.file-input-controls').addClass('-has-files');
		} else {
			for (var i = 0; i < filesLength; i++) {
				$(self).siblings('.files').append('<li class="upload-percent" data-nr="'+i+'"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23px" height="32px"><path fill-rule="evenodd" d="M14.414,-0.000 L-0.000,-0.000 L-0.000,32.000 L23.000,32.000 L23.000,8.586 L14.414,-0.000 ZM15.000,3.414 L19.586,8.000 L15.000,8.000 L15.000,3.414 ZM21.000,30.000 L2.000,30.000 L2.000,2.000 L13.000,2.000 L13.000,10.000 L21.000,10.000 L21.000,30.000 ZM10.000,10.000 L6.000,10.000 L6.000,12.000 L10.000,12.000 L10.000,10.000 ZM6.000,16.999 L17.000,16.999 L17.000,15.000 L6.000,15.000 L6.000,16.999 ZM6.000,22.000 L17.000,22.000 L17.000,20.000 L6.000,20.000 L6.000,22.000 ZM6.000,27.000 L15.000,27.000 L15.000,25.000 L6.000,25.000 L6.000,27.000 Z"/></svg><div class="upload-item"><p class="clamp">'+self.files[i].name+'</p><div class="upload-bar"><div class="done"></div></div></div></li>');
			}
			$(self).closest('.file-input-controls').addClass('-has-files');
		}
		//app.handleMobileTitleLength();
	});
	$('body').on('click', '.reset-files', function(e) {
		var el = $(this).siblings('input[type="file"]');
		el.wrap('<form class="temporary-form">');
		el.closest('form').get(0).reset();
		el.unwrap();
		el.siblings('.files').html('');
		el.closest('.file-input-controls').removeClass('-has-files');
		uploadajaxOper('reset', null, function() {});
	});

	if ($( ".-upload-file .files" ).length) {
		$( ".-upload-file .files" ).sortable({
			stop: function(e,ui){
				uploadajaxOper('sort', $( ".-upload-file .files" ).sortable('toArray', {attribute: 'data-nr'}), null);
			}
		});	
	}
};


function uploadajaxOper(oper, data, _func) {
	form_data = new FormData();
	form_data.append("oper", oper);
	form_data.append("form_id", parseInt($('input[name=form_id]').val()));
	if (data!=null)
		form_data.append("data", data);
	var request = $.ajax({
		url: "/upload-ajax",
		cache: false,
		contentType: false,
		processData: false,
		async: true,
		data: form_data,
		type: 'POST',
		success: function (res, status) {
			if (status == 'success') {
				//console.log('Success '+oper);
				if (_func)
					_func();
			}
		},
		fail: function (res) {
			//console.log('Failed');
		}
	});
}

function uploadajax(fileLength, position) {
	var form_data =  "";
	var uploadField = $("input[type='file']");
	var fileList = uploadField.prop('files');
	var file = fileList[position];

	form_data = new FormData();
	form_data.append("upload_file", file);
	form_data.append("position", position);
	form_data.append("form_id", parseInt($('input[name=form_id]').val()) );
	form_data.append("field_id", parseInt(uploadField.attr('data-field_id')) );
	//console.log(form_data);

	if (file) {
		var request = $.ajax({
			xhr: function() {
				var xhr = new window.XMLHttpRequest();
				xhr.upload.addEventListener("progress", function(evt) {
					if (evt.lengthComputable) {
						var percentComplete = (evt.loaded / evt.total) * 100;
						percentComplete = Math.round(percentComplete)+'%';

						$('.-upload-file').find('.files').find('.upload-bar').find('.done').css('max-width', percentComplete);
					}
				}, false);
				return xhr;
			},
			url: "/upload-ajax",
			cache: false,
			contentType: false,
			processData: false,
			async: true,
			data: form_data,
			dataType: 'json',
			type: 'POST', 
			success: function (res, status) {
				if (status == 'success') {
					percent = 0;
					// console.log('Done ' + res.status);
					if (res.status)
						$(".files > li:eq(" + position + ")").removeClass('upload-percent').addClass('upload-done');
					else
						$(".files > li:eq(" + position + ")").removeClass('upload-percent').addClass('upload-error');
					if (position + 1 < number_of_files)
						uploadajax(fileLength, position + 1);
				}
			},
			fail: function (res) {
				//console.log('Failed');
			}
		});
	}
}